module.exports = __webpack_public_path__ + "static/media/empty-state-other-cms.09862aa9.svg";